import gql from 'graphql-tag'

export const barcodeSettingQuery = gql`
  query BarcodeSetting($accountId: Int, $id: ID, $dataSource: String) {
    barcodeSetting(accountId: $accountId, id: $id, dataSource: $dataSource) {
      id
      accountId
      barcodeLabelId
      name
      output
      barcodeType
      size
      labelFormat
      digits
      prefix
      startNumber
      startingCode
      dataSource
      entityId
      fieldId
      details
      sheet {
        id
        accountId
        name
        size
        width
        height
        topMargin
        bottomMargin
        leftMargin
        rightMargin
        rows
        columns
        rowGutter
        columnGutter
        unit
      }
      label {
        id
        accountId
        barcodeSheetId
        name
        width
        height
        elements
      }
      lastPrinted
      nextToPrint
      reprintEndNumber
    }
  }
`
